import * as React from "react";

export enum WhatsNextOptionId {
  DoctorChat = "DoctorChat",
  ViewSummary = "ViewSummary",
  SendToDoctor = "SendToDoctor",
  SaveAssessment = "SaveAssessment",
  StartOver = "StartOver",
}

export type WhatsNextOption = {
  name: WhatsNextOptionId;
  displayText?: string;
  component: React.ComponentType<any>;
  allowForPartner?: (partnerId) => boolean;
  icon?: React.ComponentType<any>;
  backgroundColor?: string;
  // Does this option depend on a flag?
  featureFlag?: string;
};
